module.exports = __webpack_public_path__ + "static/img/6.a934195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/6.png
// module id = 8Zst
// module chunks = 0